import React, { memo, useCallback, useState } from 'react';
import usePlayerEvent from '../../_hooks/use-player-event';
import { PlayerEvent } from '../../types';
import testIds from '@smart-tv/e2e/shared/variables';
import getLiveProgress from '@smart-tv/utils/content/get-live-progress';
import Slider from './slider';
import styles from './player-controls-scrubber.module.scss';

const sliderClassNames = {
  bar: styles['player-controls-scrubber-live-tv-slider__bar'],
  track: styles['player-controls-scrubber-live-tv-slider__track'],
  range: styles['player-controls-scrubber-live-tv-slider__range'],
  handle: styles['player-controls-scrubber-live-tv-slider__handle']
};

interface Props {
  endTime?: Date;
  startTime?: Date;
}

export const PlayerControlsScrubberLiveTv = (props: Props) => {
  const { startTime, endTime } = props;

  const [progress, setProgress] = useState(0);

  const handlePlaytimeUpdated = useCallback(() => {
    if (!startTime || !endTime) return;

    const progress = getLiveProgress(startTime, endTime);

    setProgress(progress);
  }, [startTime, endTime]);

  usePlayerEvent(PlayerEvent.PlayTimeUpdated, handlePlaytimeUpdated);

  return (
    <Slider
      startTime={startTime}
      endTime={endTime}
      progressPercentage={progress}
      classNames={sliderClassNames}
      color="success"
      data-testid={testIds.player.playerControls.scrubber}
    />
  );
};

export default memo(PlayerControlsScrubberLiveTv);
